import React from 'react';
import ExerciseInterface from './ExerciseSystem/ExerciseInterface';
import { M01_TOPICS, M01_MODULE_INFO, getAllM01Problems } from '../data/mathExercises/M01_NumberSystemsApproximations';

const M01NumberSystemsExercise = ({ onProgress }) => {
  const topics = M01_TOPICS;
  const problems = getAllM01Problems();
  const moduleInfo = M01_MODULE_INFO;

  return (
    <ExerciseInterface
      moduleInfo={moduleInfo}
      topics={topics}
      problems={problems}
      onProgress={onProgress}
      className="m01-exercise"
    />
  );
};

export default M01NumberSystemsExercise; 